import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=6e8520d0"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=6e8520d0&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8520d0')) {
      api.createRecord('6e8520d0', component.options)
    } else {
      api.reload('6e8520d0', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=6e8520d0", function () {
      api.rerender('6e8520d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/marketing_place/product/Form.vue"
export default component.exports